export function detectBrowserLanguage(supported = ['pt', 'en', 'es'], fallback = 'en') {
  const raw = (navigator.language || navigator.userLanguage || '').toLowerCase();
  const base = raw.split('-')[0];
  return supported.includes(base) ? base : fallback;
}
